import {RequestParameters} from 'maplibre-gl';
import {keycloakService} from '@ndw/react-keycloak-authentication';
import {firstValueFrom} from 'rxjs';
import {MAPS_SERVER_BASE_URL} from '../../applicationContext';
import {Log} from '../../utils/log';

const TOKEN_REFRESH_INTERVAL_MS = 10000;

// MapLibre resolves transformRequest synchronously, so the access token has to be kept in memory
let cachedAccessToken: string | null = null;
let tokenRefreshInterval: NodeJS.Timeout | undefined;

const refreshCachedAccessToken = async (): Promise<void> => {
    try {
        cachedAccessToken = await firstValueFrom(keycloakService.token());
    } catch (error) {
        Log.warn(error);
        cachedAccessToken = null;
    }
};

export const startCachingMapsAccessToken = async (): Promise<void> => {
    await refreshCachedAccessToken();

    if (!tokenRefreshInterval) {
        tokenRefreshInterval = setInterval(() => {
            void refreshCachedAccessToken();
        }, TOKEN_REFRESH_INTERVAL_MS);
    }
};

export const stopCachingMapsAccessToken = (): void => {
    if (tokenRefreshInterval) {
        clearInterval(tokenRefreshInterval);
        tokenRefreshInterval = undefined;
    }
};

export const transformMapsRequest = (url: string): RequestParameters => {
    if (!url.startsWith(MAPS_SERVER_BASE_URL) || !cachedAccessToken) {
        return {url};
    }

    return {
        url: url,
        method: 'GET',
        headers: {
            Authorization: `Bearer ${cachedAccessToken}`,
        },
    };
};
